import Pill from "@buildpy/ui/pill";

interface Props {
  count: number;
  testId?: string;
}

// 공정 지연 N — 판정은 delayedPhaseCount 가 하고 0 이면 그리지 않는다.
const PhaseDelayPill = ({ count, testId }: Props) =>
  count > 0 ? (
    <span className="shrink-0" data-testid={testId}>
      <Pill className="whitespace-nowrap" tone="danger">
        지연 {count}
      </Pill>
    </span>
  ) : null;

export default PhaseDelayPill;
